export enum ExternalSourceType {
    USA_WRESTLING = 'usa-wrestling',
    EVENTBRITE = 'eventbrite',
    TRACKWRESTLING = 'trackwrestling',
}

/**
 * Model for an externalLink (e.g. usa wrestling, eventbrite, etc)
 */
export class ExternalLink {
    public id: string = null;
    public eventId: string = null;
    public externalSource: ExternalSourceType = null;
    public externalId: string = null;
    public buttonText: string = null;

    constructor(externalSource?: ExternalSourceType) {
        this.externalSource = externalSource;
    }

    public isEqual(source: ExternalLink): boolean {
        if (!source) {
            return false;
        }

        return this.externalSource === source.externalSource &&
            (this.externalId || '') === (source.externalId || '') &&
            (this.buttonText || '') === (source.buttonText || '');
    }

    /**
     * Clone the ExternalLink object. This is used to prevent object reference issues
     */
    public clone(): ExternalLink {
        const clone: ExternalLink = new ExternalLink();
        clone.id = this.id;
        clone.eventId = this.eventId;
        clone.externalSource = this.externalSource;
        clone.externalId = this.externalId;
        clone.buttonText = this.buttonText;

        return clone;
    }

    /**
     * Serialize to a json api format
     */
    public serialize(): string {
        const json: any = {
            data: {
                type: 'externalLink',
                id: this.id,
                attributes: {
                    externalSource: this.externalSource,
                    externalId: this.externalId,
                    buttonText: this.buttonText,
                },
            },
        };

        return JSON.stringify(json);
    }

    /**
     * Deserialize from a json api format
     */
    public deserialize(json: any): ExternalLink {
        const data: any = json.data || json;
        const attrs: any = data.attributes;

        this.id = data.id;
        this.eventId = attrs.eventId;
        this.externalSource = attrs.externalSource;
        this.externalId = attrs.externalId;
        this.buttonText = attrs.buttonText;

        return this;
    }
}
